@import '../variables';
@import "../modules/containers";
@import 'common/scss/styles';
@import 'common/scss/rfq-animation';
@import "../modules/progress-bar";
@import '../_common-elements';
@import "../modules/landing/landing-footer";

$imgPath: "../../static/images/landings/tech-summit";

:root {
    --bg-color: #000;
    --bg-modal-color: #0A101D;
    --bg-modal-sub-color: #0D1629;
    --bottom-footer-bg-color: #DDA400;
    --bottom-footer-text-color: #000;
    --text-modal-color: #B9B9B9;
    --text-color: #fff;
    --text-color2: #E6E6E6;
    --text-color3: #898F98;
    --primary-color: #DDA400;
    --primary-color50: #F4BD6980;
    --btn-default-bg: #FFFFFF1A;
    --icon-color: #F1DB91;
    --err-color: #ff0000;
    --footer-bg: #040404;
    --footer-title: #fd6216;
    --input-border-color: #D0D5DD30;
}

$containerMaxWidth: 1350px;
$xxs-breakpoint: 575px;

@media (min-width: $containerMaxWidth) {
    .container {
        max-width: $containerMaxWidth - 30px;
    }
}

body, .section {
    background-color: var(--bg-color);
}
.section {
    color: var(--text-color);
    position: relative;
}

body:has(.modal.m-show) {
    overflow: hidden;
}

.top {
    width: 100%;

    .container {
        padding: 36px 0;
        gap: 2rem;
        justify-content: space-between;
        transition: padding .5s;

        @media (max-width: $xs-breakpoint) {
            flex-direction: column;
            gap: 1rem;

            h1 {
                font-size: 1.5rem;
                line-height: 1.7rem;
            }

            .btn-box {
                width: 100%;

            }
        }
    }

    .head-box {
        max-height: 300px;
        transition: max-height .5s;
    }
}

.sticky {
    position: fixed;
    top: $menuHeightMobileHigher;
    z-index: 2;
    border-top: 1px solid var(--input-border-color);
    transition: top .5s;
}

body.down > .section.top {
    .container {
        padding-top: 0 !important;
        padding-bottom: 1rem !important;
    }

    .head-box {
        max-height: 0;
        overflow: hidden;
    }
}

#main-menu:not(.higher) ~ .sticky {
    top: $menuHeightMobile;
    box-shadow: 0 0 7px var(--input-border-color);

    .container {
        padding-top: 20px;
        padding-bottom: 20px;
    }
}


.section .container {
    display: flex;
    align-items: flex-start;

    &.two-col {
        align-items: center;

        @media (max-width: $medium-breakpoint) {
            flex-direction: column;

            &.md-reverse {
                flex-direction: column-reverse;
            }
        }
        @media (max-width: $xxs-breakpoint) {
            align-items: flex-start;
        }
    }
}

@media (max-width: $xxs-breakpoint) {
    .section .container {
        &.p15, .p15 {
            padding-left: 1rem;
            padding-right: 1rem;
        }
    }
}

h1 {
    font: 600 36px/38px $Exo-two;
    letter-spacing: -.01em;
}
h2 {
    font: 600 3rem/3.75rem $Exo-two;
    letter-spacing: -.01em;

    &.big {
        font: 700 52px $Exo-two;
        letter-spacing: -.01em;
    }
}
@media (max-width: $xs-breakpoint) {
    h1 {
        font-size: 1.5rem;
        line-height: 1.7rem;
    }
    h2, h2.big {
        font-size: 2rem;
        line-height: 2.7rem;
    }
}

.btn {
    font: 500 1.125rem $Exo-two;
    letter-spacing: -0.02em;
    border-radius: 6px;
}
.btn-secondary {
    background-color: var(--btn-default-bg);
    color: var(--text-color) !important;
}
.btn-primary {
    background-color: var(--primary-color);
    color: var(--bg-color) !important;
}
.btn-md {
    padding: 1rem;

    @media (max-width: $xs-breakpoint) {
        padding: 10px 1rem;
    }
}

.text-center {
    text-align: center;
}

.text-grey {
    color: var(--text-color3)
}

.btn-wrap {
    display: flex;
    gap: 12px;
}

.btn-box {
    display: flex;
    gap: 1rem;
    margin-top: .5rem;
    flex-wrap: wrap;

    .btn {
        width: calc(50% - 0.5rem);
        min-width: 140px;
        margin-left: auto;
    }
}
.time-box {
    display: flex;
    gap: 1rem 44px;
    margin-top: 1.5rem;
    flex-wrap: wrap;

    .svg-icon {
        font: 600 1rem $Open-Sans;
        letter-spacing: -0.02em;
    }

    @media (max-width: $xs-breakpoint) {
        margin-top: 1rem;
        gap: .5rem 1.25rem;

        .svg-icon {
            font-size: .75rem;
        }
    }
}

$icon: 2px solid var(--primary-color);
.list-icons > li {
    padding-left: 1.5rem;
    position: relative;
    line-height: 1.5rem;
    margin-top: 1rem;

    &:before {
        content: '';
        position: absolute;
        top: 6px;
        left: 0;
        width: 9px;
        height: 5px;
        border-bottom: $icon;
        border-left: $icon;
        transform: rotate(-51deg);
    }
}

.section-gallery {
    background-color: #0A101D;
    padding: 4rem 0;

    h2 {
        margin-bottom: 60px;
    }

    @media (max-width: 600px) {
        .container-lg {
            padding: 0;
            max-width: 100%;
        }
    }
}

.centered {
    text-align: center;
    color: #fff;
    padding: 75px 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 410px;

    &>* {
        z-index: 0;
    }

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    &.brand {
        background: #000F22 url("#{$imgPath}/bg22.jpeg") no-repeat 50% 50% fixed;
        position: relative;
        background-size: 100%;

        &:before {
            background-color: #0000008A;
        }

        @media (max-width: $xs-breakpoint) {
            background-size: cover;
        }
    }
    &.innovation {
        background: #000F22 url("#{$imgPath}/bg-lines2.jpeg") no-repeat 0 center;
        background-size: 74%;

        &:before {
            background-color: #0404049C;
        }

        @media (max-width: $medium-breakpoint) {
            background-size: cover;
            background-position: 50% 50%;
        }
    }

    p {
        font: 600 1.25rem/30px $Open-Sans;
        line-height: 30px;
        letter-spacing: -0.02em;
        margin-top: 1.5rem;
        margin-bottom: 1.5rem;
        max-width: 1200px;
        color: var(--text-color);
    }
}


.two-col {
    display: flex;
    gap: 2rem 80px;
    padding: 70px 0;

    @media (max-width: $sm-breakpoint){
        flex-wrap: wrap;
    }

    img {
        width: 590px;
        object-fit: cover;
        flex-shrink: 0;
    }

    @media (max-width: $xs-breakpoint){
        gap: 1rem 20px;
        padding: 2rem 0;

        img {
            width: 100%;
        }
    }
}

.s1 {
    align-items: center;
    background: url("#{$imgPath}/bg42.jpeg") no-repeat 0 0 fixed;
    background-size: cover;
    position: relative;
    margin-top: 167px;
    overflow: hidden;

    .two-col {
        padding-top: 0;
        padding-bottom: 0;
    }

    button {
        margin-top: 2.5rem;

        @media (max-width: $xs-breakpoint) {
            margin-top: 1.25rem;
        }
    }


    .left {
        width: 570px;
        flex-shrink: 0;
    }

    .right {
        width: 846px;
        flex-shrink: 0;
        min-height: 640px;
        margin-right: -10%;
        position: relative;

        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: -40px;
            bottom: 0;
            background: url("#{$imgPath}/bg12.png") no-repeat 0 center;
            background-size: cover;
        }
    }

    .centered-block {
        position: absolute;
        left: 28%;
        top: 33%;
        width: 390px;
        z-index: 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 1rem;

        img {
            width: auto;
            height: 100%;
            object-fit: contain;
        }
        .img-row {
            //height: 17px;
            display: flex;
            justify-content: center;
        }
        .img-row:nth-child(1) {
            height: 84px;
            width: 100%;
            margin-bottom: 4px;
        }
        .img-row:nth-child(2) {
            height: 19px;
            justify-content: flex-end;
            width: 44%;
        }
        .img-row:nth-child(3) {
            width: 49%;
            height: 34px;
            justify-content: flex-start;
        }
        .img-row:nth-child(4) {
            height: 23px;
            margin-right: -.4rem;
        }
        .img-row:nth-child(5) {
            height: 24px;
        }
        .img-row:nth-child(6) {
            height: 20px;
            margin-top: -6px;
        }
        .img-row:nth-child(7) {
            height: 21px;
            margin-top: -2px;
        }
        .img-row:nth-child(8) {
            height: 19px;
            margin-top: -1px;
        }

    }

    @media (max-width: $containerMaxWidth) {
        .two-col {
            gap: 2rem;
        }

        .left {
            max-width: 570px;
        }

        .right {
            width: 50%;
            margin-right: 0;

            &:before {
                background-position: 45% center;
            }
        }
        .centered-block {
            left: 19%;
            //top: 33%;
        }
    }

    @media (max-width: 1185px) {
        margin-top: 270px;
    }
    @media (max-width: $medium-breakpoint) {
        .right {
            width: 100%;
            margin-right: 0;
            background-position: 50% 50%;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .centered-block {
            position: relative;
            top: auto;
            left: auto;
        }
    }
    @media (max-width: $sm-breakpoint) {
        .two-col {
            flex-direction: column;
        }

        .right:before {
            right: 0;
        }

        .left {
            max-width: 100%;
            width: 100%;
        }
    }
    @media (max-width: $xs-breakpoint) {
        .right {
            align-items: flex-end;
            min-height: 520px;

            &:before {
                background-position: 47% 1%;
                background-size: 243%;
                height: 58%;
                max-height: 233px;
            }
        }

        .centered-block {
            margin-top: 1rem;
            padding-bottom: 3rem;
        }
    }

    @media (max-width: 450px) {
        .centered-block {
            max-width: 280px;

            .img-row:nth-child(2) {
                width: 37%;
            }
        }

        .right {
            min-height: 510px;
        }
    }
}


.highlights {
    background-color: var(--bg-modal-color);
    padding: 80px 0;

    @media (max-width: $xs-breakpoint){
        padding: 2rem 0;
    }

    h2 {
        text-align: center;
    }

    .list {
        display: flex;
        flex-wrap: wrap;
        gap: 1.25rem 1rem;
        margin-top: 50px;
        justify-content: center;

        li {
            flex: 0 1 calc(25% - 1rem);
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 1rem;
            min-width: 300px;
        }

        b {
            display: block;
            font: 600 1.25rem/30px $Open-Sans;
            margin-top: 1rem;
            text-align: center;
        }

        p {
            font: 400 1rem/24px $Open-Sans;
            text-align: center;
            color: var(--text-color3)
        }
    }
}

.text-box {
    flex-grow: 1;
    max-width: 570px;

    p {
        font: 400 1.125rem/27px $Open-Sans;
        margin-top: 1.5rem;
    }

    .btn {
        margin-top: 1.5rem;
    }

    h4 {
        font: 700 1.125rem/27px $Open-Sans;
    }
}

.mt-20 {
    margin-top: 20px;
}
.ml-40 {
    margin-left: 40px;

    @media (max-width: $sm-breakpoint){
        margin-left: 0;
    }
}

.sponsors {
    background: url("#{$imgPath}/sponsors-bg.svg") no-repeat 50% 50%;
    background-size: cover;
    position: relative;

    &:before, &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    &:before {
        z-index: -1;
        background: linear-gradient(90deg, #D1992A 0%, #F7C84A 100%);
    }
    &:after {
        background: radial-gradient(132.95% 132.95% at 50% 50%, rgba(255, 255, 255, 0.46) 0%, rgba(255, 255, 255, 0) 54%);
    }

    .container {
        padding: 75px 1rem 85px 1rem;
        align-items: center;
        flex-direction: column;
        position: relative;
        z-index: 1;
        max-width: 100%;
    }

    h2 {
        color: #0A0A0A;
        text-align: center;
    }
}

.event-recap {
    background-color: #050a14;
    color: #ffffff;
    padding: 60px 20px;
    font-family: 'Arial', sans-serif;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
}

.section-title {
    text-align: center;
    font-size: 2.5rem;
    font-weight: 600;
    margin-bottom: 40px;
    letter-spacing: -0.5px;
}

.gallery-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
}

.gallery-item {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    overflow: hidden;
}

.gallery-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.3s ease;
}

@media (any-hover: hover) {
    .gallery-item:hover img {
        transform: scale(1.05);
    }
}
.gallery-item:active img {
    transform: scale(1.05);
}

@media (max-width: 992px) {
    .gallery-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 600px) {
    .gallery-grid {
        grid-template-columns: 1fr;
    }

    .section-title {
        font-size: 2rem;
    }
}

.sponsor-logos {
    display: flex;
    flex-wrap: wrap;
    gap: 4rem 60px;
    justify-content: center;
    max-width: 1030px;
    margin: 62px auto 0 auto;


    img {
        object-fit: contain;

        &:nth-child(1) {
            height: 37px;
            margin-left: calc(50% - 193px);
        }
        &:nth-child(2) {
            height: 60px;
            margin-left: 8px;
            margin-right: calc(50% - 231px);
        }
        &:nth-child(3) {
            height: 53px;
            margin-left: 44px;
            margin-right: -30px;
        }
        &:nth-child(4) {
            height: 57px;
            margin-right: -10px;
        }
        &:nth-child(5) {
            height: 47px;
            margin-top: -13px;
        }
        &:nth-child(6) {
            height: 47px;
            margin-top: -3px;
        }
        &:nth-child(7) {
            height: 100px;
            margin-left: calc(50% - 167px);
        }
        &:nth-child(8) {
            margin-top: -5px;
            height: 110px;
            margin-right: calc(50% - 142px);
        }
    }

    @media (max-width: $medium-breakpoint){
        max-width: 530px;
        margin-left: auto;
        margin-right: auto;

        img {
            &:nth-child(1) {
                margin-left: 10px;
            }
            &:nth-child(2) {
                margin-right: -12px;
            }
            &:nth-child(3) {
                margin-left: 60px;
                margin-right: 0;
            }
            &:nth-child(7) {
                margin-left: 0;
            }
            &:nth-child(8) {
                margin-right: 28px;
            }
        }
    }

    @media (max-width: $xs-breakpoint){
        flex-direction: column;

        img {
            &:nth-child(1) {
                margin-left: 20px;
            }
            &:nth-child(2) {
                margin-right: 0;
            }
            &:nth-child(3) {
                margin-left: 37px;
            }
            &:nth-child(6) {
                margin-right: 13px;
            }
            &:nth-child(8) {
                margin-right: 0;
            }
        }
    }
}

.inc-hover {
    transition: transform .5s;
    touch-action: manipulation;

    @media (any-hover: hover) {
        &:hover {
            transform: scale(1.2);
        }
    }
    &:active {
        transform: scale(1.2);
    }
}

//************************** svg-icon *************************
//************************** svg-icon *************************
$iconSize: 34px;
a.svg-icon, .svg-icon {
    min-height: $iconSize;
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--primary-color);
    flex-shrink: 0;

    @media (max-width: $sm-breakpoint){
        flex-shrink: 1;
    }

    &:before {
        content: '';
        width: $iconSize;
        height: $iconSize;
        background-repeat: no-repeat;
        background-size: 20px 20px;
        background-position: 50% 50%;
        border: 1px solid var(--primary-color50);
        border-radius: 6px;
        flex-shrink: 0;
    }

    @media (max-width: $xs-breakpoint) {
        &:before {
            content: '';
            width: 1.25rem;
            height: 1.25rem;

            background-size: 1rem 1rem;
        }
    }
}

.svg-icon.calendar:before {
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.66797 1.66797V4.16797' stroke='%23F4BD69' stroke-width='1.5' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M13.332 1.66797V4.16797' stroke='%23F4BD69' stroke-width='1.5' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M2.91797 7.57422H17.0846' stroke='%23F4BD69' stroke-width='1.5' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M17.5 7.08464V14.168C17.5 16.668 16.25 18.3346 13.3333 18.3346H6.66667C3.75 18.3346 2.5 16.668 2.5 14.168V7.08464C2.5 4.58464 3.75 2.91797 6.66667 2.91797H13.3333C16.25 2.91797 17.5 4.58464 17.5 7.08464Z' stroke='%23F4BD69' stroke-width='1.5' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M13.0762 11.4167H13.0836' stroke='%23F4BD69' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M13.0762 13.9167H13.0836' stroke='%23F4BD69' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M9.99412 11.4167H10.0016' stroke='%23F4BD69' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M9.99412 13.9167H10.0016' stroke='%23F4BD69' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M6.91209 11.4167H6.91957' stroke='%23F4BD69' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M6.91209 13.9167H6.91957' stroke='%23F4BD69' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
}
.svg-icon.clock:before {
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18.3346 10.0013C18.3346 14.6013 14.6013 18.3346 10.0013 18.3346C5.4013 18.3346 1.66797 14.6013 1.66797 10.0013C1.66797 5.4013 5.4013 1.66797 10.0013 1.66797C14.6013 1.66797 18.3346 5.4013 18.3346 10.0013Z' stroke='%23F4BD69' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M13.0914 12.6495L10.5081 11.1078C10.0581 10.8411 9.69141 10.1995 9.69141 9.67448V6.25781' stroke='%23F4BD69' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
}
.svg-icon.place:before {
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.99844 11.1922C11.4344 11.1922 12.5984 10.0281 12.5984 8.59219C12.5984 7.15625 11.4344 5.99219 9.99844 5.99219C8.5625 5.99219 7.39844 7.15625 7.39844 8.59219C7.39844 10.0281 8.5625 11.1922 9.99844 11.1922Z' stroke='%23F4BD69' stroke-width='1.5'/%3E%3Cpath d='M3.0187 7.0763C4.66037 -0.140363 15.352 -0.132029 16.9854 7.08464C17.9437 11.318 15.3104 14.9013 13.002 17.118C11.327 18.7346 8.67704 18.7346 6.9937 17.118C4.6937 14.9013 2.06037 11.3096 3.0187 7.0763Z' stroke='%23F4BD69' stroke-width='1.5'/%3E%3C/svg%3E");
}

.hl-icon {
    background-size: 21px 20px;
    background-repeat: no-repeat;
    width: 21px;
    height: 20px;
}
.icon1 {
    background-image: url("data:image/svg+xml,%3Csvg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.5 2.62268e-07V6V20H14.5V13.0033C14.4982 16.8678 11.3649 20 7.5 20C3.63401 20 0.5 16.866 0.5 13C0.5 9.13401 3.63401 6 7.5 6C11.3649 6 14.4982 9.13222 14.5 12.9967V6H7.5H0.5V2.62268e-07L14.5 0L20.5 2.62268e-07Z' fill='%23F1DB91'/%3E%3C/svg%3E");
}
.icon2 {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.5 0H0.5V10C0.5 15.5228 4.97715 20 10.5 20C16.0228 20 20.5 15.5228 20.5 10V0H15.5C12.7386 0 10.5 2.23858 10.5 5C10.5 2.23858 8.26142 0 5.5 0Z' fill='%23F1DB91'/%3E%3C/svg%3E");
}
.icon3 {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.05492 17.8786L8.05488 17.8787L6.79138 16.6152C6.79709 16.6927 6.8 16.771 6.8 16.85C6.8 18.5897 5.3897 20 3.65 20C1.9103 20 0.5 18.5897 0.5 16.85C0.5 15.1103 1.9103 13.7 3.65 13.7C3.72899 13.7 3.8073 13.7029 3.88483 13.7086L2.58627 12.4101L2.58654 12.4098C1.29585 11.0931 0.5 9.28947 0.5 7.3C0.5 3.26832 3.76832 0 7.8 0C9.78947 0 11.5931 0.795845 12.9098 2.08654L12.91 2.0863L12.9491 2.12532C12.9576 2.13384 12.9662 2.14239 12.9747 2.15095L14.2086 3.3849C14.2029 3.30735 14.2 3.22901 14.2 3.15C14.2 1.4103 15.6103 0 17.35 0C19.0897 0 20.5 1.4103 20.5 3.15C20.5 4.8897 19.0897 6.3 17.35 6.3C17.271 6.3 17.1927 6.29709 17.1151 6.29137L18.3492 7.52547C18.3577 7.53389 18.3661 7.54234 18.3745 7.5508L18.3786 7.55491C19.6898 8.8746 20.5 10.6927 20.5 12.7C20.5 16.7317 17.2317 20 13.2 20C11.1927 20 9.37461 19.1898 8.05492 17.8786Z' fill='%23F1DB91'/%3E%3C/svg%3E");
}
.icon4 {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.5 0H20.5V5V15L15.5 20V5H0.5L5.5 0ZM0.5 16.5067V10H7.0067L0.5 16.5067ZM10.5 20H4.07777L10.5 13.5778V20Z' fill='%23F1DB91'/%3E%3C/svg%3E");
}
.icon5 {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.5 5V4.37114e-07L10.5 0V4.99803C10.4989 2.23751 8.26077 4.37114e-07 5.5 4.37114e-07H0.5V10H5.5C2.73858 10 0.5 12.2386 0.5 15L0.5 20H10.5V15C10.5 17.7614 12.7386 20 15.5 20H20.5V10H15.502C18.2625 9.99893 20.5 7.76077 20.5 5Z' fill='%23F1DB91'/%3E%3C/svg%3E");
}
.icon6 {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.4998 0H4.3C2.20132 0 0.5 1.70132 0.5 3.8V16.2C0.5 18.2987 2.20132 20 4.3 20H10.4998C10.4999 19.9834 10.5 19.9667 10.5 19.95C10.5 19.9667 10.5001 19.9834 10.5002 20H16.7C18.7987 20 20.5 18.2987 20.5 16.2V3.8C20.5 1.70132 18.7987 0 16.7 0H10.5002C10.5271 2.76601 12.7776 5 15.55 5H15.5C12.7386 5 10.5 7.23858 10.5 10C10.5 7.23858 8.26142 5 5.5 5H5.45C8.22235 5 10.4729 2.76601 10.4998 0ZM10.5 10C10.5 12.5286 8.62299 14.6188 6.18629 14.9533C8.62634 15.3097 10.5 17.4111 10.5 19.95C10.5 17.4111 12.3737 15.3097 14.8137 14.9533C12.377 14.6188 10.5 12.5286 10.5 10Z' fill='%23F1DB91'/%3E%3C/svg%3E");
}
.icon7 {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='30' viewBox='0 0 29 30' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M18.0355 4.39344L14.5 0.85791L7.42893 7.92898L10.9645 11.4645C9.01185 9.51189 5.846 9.51191 3.8934 11.4645L0.357865 15L7.42893 22.0711L10.9645 18.5356C9.01186 20.4882 9.01186 23.654 10.9645 25.6066L14.5 29.1422L21.5711 22.0711L18.0355 18.5356C19.9881 20.4882 23.154 20.4882 25.1066 18.5356L28.6421 15L21.5711 7.92898L18.0355 11.4645C19.9882 9.51189 19.9882 6.34606 18.0355 4.39344ZM14.5 15L10.9645 11.4645C12.9171 13.4171 12.9171 16.583 10.9645 18.5356L14.5 15ZM14.5 15L18.0355 11.4645C16.0829 13.4171 16.0829 16.583 18.0355 18.5356L14.5 15Z' fill='%23F1DB91'/%3E%3C/svg%3E");
}
.icon8 {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0.5 10L0.5 0L10.5 4.37114e-07C10.5 5.52285 6.02285 10 0.5 10ZM20.5 10C20.5 4.47716 16.0228 1.88558e-06 10.5 4.37114e-07V10H0.5C0.5 15.5228 4.97715 20 10.5 20H20.5V10ZM20.4961 10H10.5V20C10.5 14.4785 14.975 10.0021 20.4961 10Z' fill='%23F1DB91'/%3E%3C/svg%3E");
}



